<template>
  <div class="p-6 w-full sm:w-1/2">
    <h1 class="resume-section-title">{{ 'me-title' | lang('resume') }}</h1>
    <div class="py-1 resume-section-item text-lg hd:text-base fhd:text-2xl 4k:text-5xl">
      {{ 'me-description' | lang('resume') }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listHobbies: this.$options.filters.lang('hobbies', 'resume'),
    };
  },
  methods: {
    getHobbiesnList() {
      return this.listHobbies;
    },
  },
}
</script>